'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Tabs = require('react-bootstrap/lib/Tabs');

var _Tabs2 = _interopRequireDefault(_Tabs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Tabs2.default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@sketchpixy/rubix/lib/Tabs.js
 ** module id = ./node_modules/@sketchpixy/rubix/lib/Tabs.js
 ** module chunks = 0
 **/